<script lang="ts">
    import { get } from 'svelte/store';
    import { _ } from 'svelte-i18n';

    import { api } from '../../../stores/api';
    import { RouteOne } from './Routes/RouteOne';
    import { ConnectionApi } from './ConnectionApi';
    import { canWrite, writeDisabledTooltip } from '../../shared/Permissions/writeAccess';

    export let routeOne: RouteOne;
</script>

<textarea
    class="settings-value"
    style="width: 240px; height: 110px; border: 0;font-family: inherit; font-size: inherit; border-radius: 5px;"
    disabled={!$canWrite}
    title={$canWrite ? '' : $_(writeDisabledTooltip)}
    value={routeOne.getNote()}
    on:change={e => {
        // notatka idzie przez Connection::modify - bez can_write backend odda 403
        if (!get(canWrite)) {
            return;
        }
        let newValue = e.target?.value || '';
        routeOne.setNote(newValue);
        ConnectionApi.modify($api, { id: routeOne.getId() }, { note: newValue });
    }}
/>
